export const SET_HAS_ATTACHMENT = 'SET_HAS_ATTACHMENT';

export const SetHasAttachment = (value) => {
    return {
        type: SET_HAS_ATTACHMENT,
        payload: {
            value: value
        }
    }
}